/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TableMessagesSent_Query = {
    readonly messagesSent: ReadonlyArray<{
        readonly _id: string;
        readonly " $fragmentRefs": FragmentRefs<"TableRowMessage_Message">;
    } | null> | null;
    readonly " $refType": "TableMessagesSent_Query";
};
export type TableMessagesSent_Query$data = TableMessagesSent_Query;
export type TableMessagesSent_Query$key = {
    readonly " $data"?: TableMessagesSent_Query$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TableMessagesSent_Query">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "createdAtFrom"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "createdAtTo"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TableMessagesSent_Query",
  "selections": [
    {
      "alias": "messagesSent",
      "args": [
        {
          "fields": [
            {
              "fields": [
                {
                  "fields": [
                    {
                      "kind": "Variable",
                      "name": "gte",
                      "variableName": "createdAtFrom"
                    },
                    {
                      "kind": "Variable",
                      "name": "lte",
                      "variableName": "createdAtTo"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "createdAt"
                },
                {
                  "kind": "Literal",
                  "name": "key",
                  "value": {
                    "nin": [
                      "interactiveVoiceResponse"
                    ]
                  }
                },
                {
                  "kind": "Literal",
                  "name": "ref",
                  "value": {
                    "nin": [
                      "chatAudit",
                      "chatAuditTz"
                    ]
                  }
                },
                {
                  "kind": "Literal",
                  "name": "status",
                  "value": {
                    "in": [
                      "opened",
                      "delivered",
                      "sent",
                      "pending"
                    ]
                  }
                }
              ],
              "kind": "ObjectValue",
              "name": "_operators"
            },
            {
              "kind": "Literal",
              "name": "type",
              "value": "outbound"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Literal",
          "name": "limit",
          "value": 5
        },
        {
          "kind": "Literal",
          "name": "sort",
          "value": "_ID_DESC"
        }
      ],
      "concreteType": "Message",
      "kind": "LinkedField",
      "name": "messageMany",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "_id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TableRowMessage_Message"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
(node as any).hash = '98d6ace9d4faa4ae0be4284d128feabf';
export default node;
